<div class="chapter-card-component">
    <div *ngIf="!isLoading" class="card chapter-card" (click)="onCardClick($event, chapter)"
        (mouseover)="isHovered = true" (mouseleave)="isHovered = false">

        <div class="card-body">
            <div class="info-container">
                <mat-chip title="Chapter Status: Draft" class="draft-status"
                    *ngIf="showChapterStatusIcon('Draft')">D</mat-chip>
                <mat-chip title="Chapter Status: Waiting For Verification" class="waiting-for-verification-status"
                    *ngIf="showChapterStatusIcon('WaitingForVerification')">W</mat-chip>
                <mat-chip title="Chapter Status: Verified" class="verified-status"
                    *ngIf="showChapterStatusIcon('Verified')">V</mat-chip>
                <mat-chip title="Chapter Status: Published" class="published-status"
                    *ngIf="showChapterStatusIcon('Published')">P</mat-chip>
                <mat-chip title="Chapter Status: Retired" class="retired-status"
                    *ngIf="showChapterStatusIcon('Retired')">R</mat-chip>
            </div>
            <!-- Show Type of Chapter like Story , Visual Series, Preface -->
            <div class="chapter-type-container">
                <mat-chip [title]="getChapterTypeDisplay(chapter.Type).title"
                    [ngClass]="getChapterTypeDisplay(chapter.Type).className">{{getChapterTypeDisplay(chapter.Type).name}}</mat-chip>
            </div>
            <div class="image-container">
                <img [src]="chapter.ThumbnailUrl | transformUrl"
                    [ngClass]="{'default-thumbnail-class': !chapter.ThumbnailUrl}" alt="Chapter">

                <!-- White overlay on hover -->
                <div class="hover-overlay" *ngIf="isHovered"></div>

                <!-- Edit button appears only if canEdit is true AND isHovered -->
                <button *ngIf="canEdit && isHovered" class="edit-button" (click)="onEdit($event, chapter)" title="Edit">
                    Edit
                </button>
            </div>
        </div>

        <div class="card-footer">
            <div class="row">
                <div class="col-sm-10 chapter-card-title-container">
                    <span class="chapter-card-title" [title]="chapter.Title">{{chapter.Title}}</span>
                </div>
                <!-- Delete button appears only if canDelete is true -->
                <!-- Remove the Chapter Delete Option -->
                <!-- <div class="col-sm-2 delete-icon text-center" *ngIf="canDelete" (click)="onDelete($event, chapter)"
                    title="Delete">
                    <i class="bi bi-trash fs-6"></i>
                </div> -->
            </div>
        </div>
    </div>
    <div *ngIf="isLoading" class="card chapter-card loader">
        <div class="card-body">
            <div class="image-container">
                <!-- <img title="Thumbnail"  src="#"> -->
            </div>
        </div>

        <div class="card-footer">
            <div class="row">
                <div class="col-sm-10">
                </div>
                <div class="col-sm-2 delete-icon text-center">
                </div>
            </div>
        </div>
    </div>
</div>